import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ImageTransformationService } from '@vendasta/image-transformation';
import { StoreItem } from './store-item';

@Component({
  selector: 'store-card',
  template: `
    <mat-card appearance="outlined" class="hover-card" *ngIf="item" (click)="cardClicked.emit(item)">
      <div class="hover-area">
        <div
          class="product-banner"
          (click)="bannerClicked.emit(item)"
          [style.background-color]="item.headerImageUrl ? '' : getBannerColorForName()"
        >
          <img
            class="img-container"
            *ngIf="item.headerImageUrl"
            [src]="item.headerImageUrl"
            [srcset]="getSrcsetHeaderUrls(item.headerImageUrl)"
          />
        </div>
        <div class="description" (click)="descriptionClicked.emit(item)">
          <mat-card-header class="store-card-header">
            <va-icon mat-card-avatar [diameter]="40" [iconName]="item.name" [iconUrl]="item.iconUrl"></va-icon>
            <mat-card-title [glxyTooltip]="item.name">{{ item.name }}</mat-card-title>
            <mat-card-subtitle>
              <ng-container *ngIf="item.appPrice">
                <billing-ui-price-display
                  [appPrice]="item.appPrice"
                  [currencyCode]="currencyCode"
                  [form]="'verbose'"
                ></billing-ui-price-display>
              </ng-container>
            </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>{{ item.tagline }}</mat-card-content>
        </div>
        <button
          *ngIf="item.purchased !== undefined"
          mat-button
          color="primary"
          class="enabled-indicator"
          (click)="purchasedClicked.emit(item)"
          [disabled]="item.purchased"
        >
          <i *ngIf="!item.purchased" class="material-icons">add</i>
          <i *ngIf="item.purchased" class="material-icons" style="color: #39B74A">check</i>
          <span>
            {{ (item.purchased ? 'FRONTEND.STORE.ENABLED_UPPER' : 'FRONTEND.STORE.ENABLE_UPPER') | translate }}
          </span>
        </button>
      </div>
    </mat-card>
  `,
  styleUrls: ['./store-card.component.scss'],
  standalone: false,
})
export class StoreCardComponent {
  @Input() item: StoreItem;
  @Input() currencyCode: string;
  @Input() showAllPrices = false; // TODO: get rid of this
  @Output() purchasedClicked = new EventEmitter<StoreItem>();
  @Output() cardClicked = new EventEmitter<StoreItem>();
  @Output() descriptionClicked = new EventEmitter<StoreItem>();
  @Output() bannerClicked = new EventEmitter<StoreItem>();

  constructor(private imageTransformationService: ImageTransformationService) {}

  getBannerColorForName(): string {
    // determine an icon color for a product with no icon by using the product name
    const COLOR_CODES = [
      '#EF5350',
      '#42A5F5',
      '#66BB6A',
      '#FFA726',
      '#AB47BC',
      '#FFCA28',
      '#EC407A',
      '#26C6DA',
      '#FF7B57',
    ];
    let nameSum = 0;
    const defaultColor = '#808080';
    if (!this.item.name) {
      return defaultColor;
    }
    for (let i = 0; i < this.item.name.length; i++) {
      nameSum += this.item.name[i].charCodeAt(0);
    }
    const index = nameSum % COLOR_CODES.length;
    return COLOR_CODES[index];
  }

  getSrcsetHeaderUrls(imageUrl: string): string {
    return this.imageTransformationService.getSrcSetForImage(imageUrl, [680, 1360, 2720]);
  }
}
